import Cookies from 'js-cookie';

declare const APP_NAME: string;
declare const COOKIE_DOMAIN: string;

const getAuthTokenKey = () => {
  return `${APP_NAME}AuthToken`;
};

const getUserIdFromJwt = (jwt: string) => {
  try {
    const [, payloadSegment] = jwt.split('.');
    const payload = JSON.parse(atob(payloadSegment));
    return payload.sub as string;
  } catch {
    return null ;
  }
};

export const getAuthToken = () => {
  const authCookie = Cookies.get(getAuthTokenKey());
  return authCookie ?? localStorage.getItem(getAuthTokenKey()) ?? ''; // Temp fallback until transition complete
};

export const setAuthToken = (authToken: string) => {
  Cookies.set(getAuthTokenKey(), authToken, {
    expires: 30,
    domain: COOKIE_DOMAIN,
  });
};

export const clearAuthToken = () => {
  Cookies.remove(getAuthTokenKey(), { domain: COOKIE_DOMAIN });
  localStorage.removeItem(getAuthTokenKey()); // Temp until transition complete
};

export const getUserId = () => {
  return getUserIdFromJwt(getAuthToken());
};

export const getRefreshCsrfToken = () => {
  return localStorage.getItem('refreshCsrfToken');
};

export const setRefreshCsrfToken = (refreshCsrfToken: string) => {
  localStorage.setItem('refreshCsrfToken', refreshCsrfToken);
};

export const clearRefreshCsrfToken = () => {
  localStorage.removeItem('refreshCsrfToken');
};
